<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Fiscale Operatore</label>
                        <b-form-input v-model="filtro.codiceFiscaleOperatore" type="search" placeholder="Codice Fiscale"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stato</label>
                        <b-form-select v-model="filtro.stato" :options="opzioniStato"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">Cerca</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">Reset Filtro</b-button>
                        <b-button variant="outline-info" @click="onClickSincronizza">
                            <i class="fas fa-cloud-download-alt"></i>
                            Aggiorna da AnDIamo
                        </b-button>
                        <b-button variant="success" @click="$refs.modalCrea.apri()">
                            <b-icon icon="plus"></b-icon>
                            Nuovo Utente
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(nominativo)="{ item }">
                        <div class="font-weight-bold">{{ item.cognome }} {{ item.nome }}</div>
                        <small class="text-muted">CF: {{ item.codiceFiscaleOperatore }}</small>
                    </template>
                    <template v-slot:cell(ruolo)="{ item }">
                        <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ item.tipoOperatoreDisplay || item.tipoOperatoreCode || "-" }}</span>
                    </template>
                    <template v-slot:cell(stato)="{ item }">
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (item.stato === 'ATTIVO' ? 'aperta' : 'da-programmare')">{{ item.stato }}</span>
                    </template>
                    <template v-slot:cell(contatti)="{ item }">{{ item.telefono || "-" }} / {{ item.email || "-" }}</template>
                    <template v-slot:cell(periodo)="{ item }">{{ formatDate(item.dataInizio) }} - {{ item.dataFine ? formatDate(item.dataFine) : "in corso" }}</template>
                    <template v-slot:cell(actions)="{ item }">
                        <router-link :to="'/andiamo/utenti/' + item.codiceFiscaleOperatore + '/view'" class="btn btn-sm btn-outline-secondary mr-1">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <b-button v-if="item.stato === 'ATTIVO'" size="sm" variant="outline-danger" class="mr-1" @click="onClickDisattiva(item)">
                            <i class="fas fa-user-slash"></i>
                        </b-button>
                        <b-button v-else size="sm" variant="outline-success" @click="onClickRiattiva(item)">
                            <i class="fas fa-user-check"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
            <no-data-component v-if="!items.length" title="Nessun utente locale: aggiorna da AnDIamo o modifica i filtri" :fontSize="15" :paddingSize="0.5" />
        </template>
        <template slot="table-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
            <AndiamoUtenteCreaModalComponent ref="modalCrea" @creato="loadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AndiamoMixin from "../mixins/AndiamoMixin";
import AndiamoUtenteCreaModalComponent from "../components/AndiamoUtenteCreaModalComponent.vue";

export default {
    components: { SaPageLayout, NoDataComponent, AndiamoUtenteCreaModalComponent },
    mixins: [UtilityMixin, AndiamoMixin],
    data() {
        return {
            rows: 0,
            perPage: 2000,
            currentPage: 1,
            showModalLoading: false,
            items: [],
            opzioniStato: [
                { value: null, text: "Tutti" },
                { value: "ATTIVO", text: "ATTIVO" },
                { value: "DISATTIVATO", text: "DISATTIVATO" },
            ],
            filtro: { codiceFiscaleOperatore: null, stato: null },
            fields: [
                { label: "Nominativo", key: "nominativo" },
                { label: "Ruolo", key: "ruolo" },
                { label: "Stato", key: "stato" },
                { label: "Contatti", key: "contatti" },
                { label: "Periodo", key: "periodo" },
                { label: "", key: "actions", tdClass: "sa-table-column-action-double" },
            ],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoUtentiLocaliPathResource;
            let params = { ...me.filtro, page: me.currentPage, forPage: me.perPage };
            axios
                .get(link, { params: params })
                .then((response) => {
                    me.items = response.data.data.list || [];
                    me.rows = response.data.data.recordsNumber || 0;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onSubmit() {
            this.currentPage = 1;
            this.loadData();
        },
        onReset() {
            this.filtro = { codiceFiscaleOperatore: null, stato: null };
            this.currentPage = 1;
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        onClickSincronizza() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoUtentiPathResource;
            axios
                .get(link, { params: {} })
                .then(() => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Utenti attivi aggiornati da AnDIamo", { title: "", variant: "success", solid: true });
                    me.loadData();
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
        onClickDisattiva(utente) {
            this.$bvModal.msgBoxConfirm("Disattivare l'utente " + utente.codiceFiscaleOperatore + "?", { title: "Conferma", okVariant: "danger" }).then((conferma) => {
                if (conferma) {
                    this.andiamoDisattivaUtente(utente.codiceFiscaleOperatore, null, null, () => {
                        this.$bvToast.toast("Utente disattivato", { title: "", variant: "success", solid: true });
                        this.loadData();
                    });
                }
            });
        },
        onClickRiattiva(utente) {
            let oggi = new Date().toISOString().slice(0, 10);
            let body = {
                codiceFiscaleOperatore: utente.codiceFiscaleOperatore,
                nome: utente.nome,
                cognome: utente.cognome,
                telefono: utente.telefono,
                email: utente.email,
                gender: utente.gender,
                tipoOperatoreCode: utente.tipoOperatoreCode,
                tipoOperatoreDisplay: utente.tipoOperatoreDisplay,
                dataInizio: oggi,
                dataFine: null,
            };
            this.andiamoInserisciUtente(body, () => {
                this.$bvToast.toast("Utente riattivato", { title: "", variant: "success", solid: true });
                this.loadData();
            });
            // this.andiamoModificaUtente(utente.codiceFiscaleOperatore, body, () => {
            //     this.$bvToast.toast("Utente riattivato", { title: "", variant: "success", solid: true });
            //     this.loadData();
            // });
        },
    },
};
</script>

<style scoped>
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
}
.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}
.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.85rem;
}
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
